import { Component, EventEmitter, Input, OnInit, Output , inject} from '@angular/core';
import { CoreCommonModule } from '@core/common.module';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService, AuthenticationService } from '@core/services/auth';
import { CbcService } from 'app/main/cbc/services/cbc.service';
import { CbcGrade } from 'app/main/cbc/models/cbc';
import { HelperFunctionsService } from '@core/services/helper-functions.service';
import { RegistrationHelpPageComponent } from 'app/main/pages/registration-help-page/registration-help-page.component';
import { TermsAndConditionsComponent } from 'app/main/pages/terms-and-conditions/terms-and-conditions.component';

@Component({
  standalone: true,
  imports: [CoreCommonModule, TermsAndConditionsComponent],
  selector: 'app-register-popup',
  templateUrl: './register-popup.component.html',
  styleUrls: ['./register-popup.component.scss']
})
export class RegisterPopupComponent implements OnInit {
  @Input() mawinguPhoneNumber: string;
  @Output() registrationSuccess = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();

  registerForm: FormGroup;
  loading = false;
  success = false;
  submitted = false;
  error: string | null = null;
  cbcGrades: CbcGrade[] = [];

  passwordTextType: boolean;
  passwordTextType2: boolean;
  agreedToTerms: boolean;

  private fb = inject(FormBuilder);
  private userService = inject(UserService);
  private cbcService = inject(CbcService);
  private helperFunctions = inject(HelperFunctionsService);
  private authenticationService = inject(AuthenticationService);
  private modalService = inject(NgbModal);

  ngOnInit(): void {
    this.registerForm = this.fb.group({
      name: ['', Validators.required],
      email: [''],
      educationSystem: ['', Validators.required],
      grade: [''],
      password: ['', [Validators.required, Validators.minLength(5)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(5)]],
    }, { validators: this.passwordMatchValidator });

    this.registerForm.get('educationSystem')?.valueChanges.subscribe((value) => {
      const gradeControl = this.registerForm.get('grade');
      if (value === 'CBC') {
        gradeControl?.setValidators(Validators.required);
      } else {
        gradeControl?.clearValidators();
        gradeControl?.setValue('');
      }
      gradeControl?.updateValueAndValidity();
    });

    this.cbcService.getDALSGrades().subscribe({
      next: (res) => { this.cbcGrades = res; }
    });
  }

  passwordMatchValidator(form: FormGroup) {
    return form.get('password')?.value === form.get('confirmPassword')?.value ? null : { mismatch: true };
  }

  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  togglePasswordTextType2() {
    this.passwordTextType2 = !this.passwordTextType2;
  }

  getAcceptedTermsStatus($event: boolean) {
    this.agreedToTerms = $event;
  }

  launchHelpModal(): void {
    const modalRef = this.modalService.open(RegistrationHelpPageComponent, {
      size: 'sm',
      keyboard: false,
    });
    modalRef.componentInstance.helpType = 'registration';
  }

  onSubmit() {
    this.submitted = true;
    if (this.registerForm.invalid || !this.agreedToTerms) {
      this.registerForm.markAllAsTouched();
      return;
    }
    this.loading = true;
    this.error = null;
    const formValue = this.registerForm.value;
    const userDetails = {
      firstName: formValue.name,
      lastName: '',
      email: formValue.email,
      phoneNumber: this.mawinguPhoneNumber,
      schoolRole: 30,
      password: formValue.password,
      educationSystem: formValue.educationSystem,
      ...(formValue.educationSystem === 'CBC' && { grade: formValue.grade }),
      mawinguAccount: this.mawinguPhoneNumber,
    };
    this.userService.addUser(userDetails).subscribe({
      next: () => {
        this.loading = false;
        this.success = true;
        this.loginAfterRegister();
      },
    error: (err) => {
        this.loading = false;
        let message = 'Registration failed. Please try again.';
        try {
          let parsedError = typeof err?.error === 'string' ? JSON.parse(err.error) : err?.error;
          if (typeof parsedError?.message === 'string' && parsedError.message.trim().startsWith('{')) {
            parsedError = JSON.parse(parsedError.message);
          }
          message = parsedError?.message || message;
        } catch {
          // fall back to default message
        }
        this.error = message;
      }
    });
  }


  loginAfterRegister() {
    const sub = this.authenticationService.mawinguUserLogin({
      username: this.mawinguPhoneNumber,
      mawinguAccount: this.mawinguPhoneNumber,
    }).subscribe({
      next: (usr) => {
        sub?.unsubscribe(); // prevent error callback firing after navigation
        const isStudent = usr.role === 30 || usr.role === 31;
        if (isStudent) {
          this.registrationSuccess.emit();
          return;
        }
        this.helperFunctions.navigateToUsersDashboard(usr);
      },
      error: () => {
        this.helperFunctions.showWarningToastr('Login failed. Please try again.');
      }
    });
  }

  close() {
    this.closeModal.emit();
  }
}